module.exports = __webpack_public_path__ + "img/TDark.6de7590c.png";